module.exports = __webpack_public_path__ + "static/media/hero-desktop.8e197ed.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/hero-desktop.mp4
// module id = 3Yhk
// module chunks = 1